import { createContext } from "react";
 
export const userContext = createContext({
    toggel : false,
    setToggel : ()=>{},
    requestStep : 1, 
    setRequestStep : ()=> {},
    estateInfo: {},
    setEstateInfo:()=> {},
    ownerInfo : {},
    setOwnerInfo: ()=>{},
    expertInfo : {},
    setExpertInfo : ()=>{},
    selectedEx : [],
    setSelectedExpert : ()=> {},
    factorInfo : {},
    setFactorInfo  : () => {}
})